<template>
    <div v-if="isOpen" class="dialog-overlay">
        <div class="dialog-box">
            <header class="dialog-header">
                <slot name="title">Default Title</slot>
                <button class="close-button" @click="closeDialog">X</button>
            </header>
            <section class="dialog-body">
                <slot>
                    Default body content goes here.
                </slot>
            </section>
            <footer class="dialog-footer">
                <slot name="footer">
                    <button @click="closeDialog">Close</button>
                </slot>
            </footer>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['update:isOpen']);

const closeDialog = () => {
    emit('update:isOpen', false);
};

</script>

<style scoped>
.dialog-overlay {
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.dialog-box {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    width: 90%;
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.close-button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.dialog-body {
    margin-bottom: 20px;
}

.dialog-footer {
    text-align: right;
}
</style>